import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Response, Http } from '@angular/http';
import { Router } from '@angular/router';

import { Observable } from 'rxjs/Observable';

import { IAuthenticationService } from '../../../+common/contracts/authentication.service.contract';
import { AUTH_ENVIRONMENT } from '../../../environment.config';
import { Account } from '../model/account.model';
import { LoginResponse } from '../model/login-response.model';
import { AuthToken } from '../model/auth-token.model';


// import * as _ from 'lodash';
// import 'rxjs/add/operator/toPromise';
// import 'rxjs/add/operator/catch';
// import 'rxjs/add/operator/map';
// import { Http } from '@angular/http';

@Injectable()
export class AuthenticationService implements IAuthenticationService {
    private _backendUrl: string;
    private _instanceType: string;

    // Begin -> Guards properties
    private redirectUrl: string = '/';
    private loginUrl: string = '/login';
    private isloggedIn: boolean;
    private loggedInUser: Account;
    // End -> Guards properties

    // isLoggedIn: BehaviorSubject<boolean>;
    // isLoggedIn$: Observable<boolean>;

    public token: string;

    constructor(private http: HttpClient, private httpOld: Http) {
        this.httpOld.get('assets/configuration/environment.json')
            .map(res => res.json())
            .toPromise()
            .then((config) => {
                this.backendUrl = config.url;
                this.instanceType = config.env;
                localStorage.setItem("backendURL", config.url);
                localStorage.setItem("exaco-instance-type", config.env);
                localStorage.setItem("impinj-url", config.impinjUrl);
                if (config.externalService) {
                    localStorage.setItem("external-service-url", config.externalService.url)
                    localStorage.setItem("external-service-auth", config.externalService.authorization)
                }

                console.log(config.url);
                console.log(config.env);
                console.log(config.impinjUrl)
            });
    }

    get backendUrl(): string {
        return localStorage.getItem("backendURL");
    }
    set backendUrl(url: string) {
        this._backendUrl = url;
    }
    get instanceType(): string {
        if (this._instanceType && this._instanceType != "")
            return this._instanceType;
        else
            return localStorage.getItem("exaco-instance-type");
    }
    set instanceType(type: string) {
        this._instanceType = type;
    }

    getUserAccount(): Account {
        let account: Account = new Account();
        account.name = localStorage.getItem('exaco-account-name');
        account.surname = localStorage.getItem('exaco-account-surname');
        account.email = localStorage.getItem('exaco-account-email');

        return account;
    }
    setUserAccount(account: Account) {
        localStorage.setItem('exaco-account-name', account.name);
        localStorage.setItem('exaco-account-surname', account.surname);
        localStorage.setItem('exaco-account-email', account.email);
        localStorage.setItem("exaco-role", account.role.id.toString());
        localStorage.setItem('exaco-company', account.company);

    }

    getToken(): string {
        // return this.token;
        return localStorage.getItem('exaco-token');
    }

    setToken(token: string): void {
        // this.token = token;
        localStorage.setItem('exaco-token', token);
    }

    setTokenFull(token: AuthToken) {
        localStorage.setItem('exaco-token', token.token);
        localStorage.setItem('exaco-token-expiry-date', token.expiryDate.toString());
        // let date = new Date("");        
    }

    loginUser(signInData: any): Observable<any> {
        throw new Error("Method not implemented.");
    }

    registerUser(registerData: any): Observable<any> {
        throw new Error("Method not implemented.");
    }

    isAuthenticated(): boolean {
        return this.getToken() && this.getToken().length > 0;
    }

    isTokenValid(): boolean {
        return new Date(localStorage.getItem('exaco-token-expiry-date')) > new Date();
    }

    //login(username: string, password: string): Observable<LoginResponse>
    login(username: string, password: string): Observable<AuthToken> {
        let account: Account = new Account();
        account.username = username;
        account.password = password;
        // return this.http
        //     .get(this.backendUrl + 'login?userName=' + username + '&password=' + password)
        //     .toPromise()
        //     .then(r => r.json());

        return this.http.post(this.backendUrl + 'login', account)
            .map(this.extractData)
            .catch(this.handleError);

    }
    logout(): void {
        this.isloggedIn = false;
    }

    setLoggedIn(flag: boolean) {
        this.isloggedIn = flag;
    }
    isUserLoggedIn(): boolean {
        return this.isloggedIn;
    }
    getRedirectUrl(): string {
        return this.redirectUrl;
    }
    setRedirectUrl(url: string): void {
        this.redirectUrl = url;
    }
    getLoginUrl(): string {
        return this.loginUrl;
    }
    getLoggedInUser(): Account {
        return this.loggedInUser;
    }
    logoutUser(): void {
        this.isloggedIn = false;
    }

    isReadonlyUser(): boolean {
        return localStorage.getItem("exaco-role") === "4";
    }
    isRegularUser(): boolean {
        return localStorage.getItem("exaco-role") === "3";
    }
    isBaseInstanceAdminUser(): boolean {
        return localStorage.getItem("exaco-role") === "2";
    }
    isMasterInstanceAdminUser(): boolean {
        return localStorage.getItem("exaco-role") === "1";
    }

    associateAccountStructures(accountId: number, structureListIds: number[]): Observable<any> {
        return this.http.post(this.backendUrl + 'accounts/' + accountId + '/associate/structures', structureListIds)
            .map(this.extractData)
            .catch(this.handleError);
    }
    getAccountStructuresAssociations(accountId: number): Observable<number[]> {
        return this.http.get(this.backendUrl + 'accounts/' + accountId + '/associate/structures')
            .map(this.extractData)
            .catch(this.handleError);
    }

    private extractData(res: any) {
        let body = res; //.json();
        return body;// || {};
    }
    private handleError(error: Response | any) {
        // In a real world app, you might use a remote logging infrastructure
        let errMsg: string;
        if (error instanceof Response) {
            const body = error.json() || '';
            const err = body.error || JSON.stringify(body);
            errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
        }
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Observable.throw(errMsg);
    }
}



// WEBPACK FOOTER //
// ./src/app/+auth/common/services/authentication.service.ts